(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["joybarba-ceremonial-matcha"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const selector = '[data-joybarba-ceremonial-matcha]';

    function ready(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
      } else {
        callback();
      }
    }

    function getSections(root) {
      if (root instanceof Element && root.matches(selector)) {
        return [root];
      }

      return Array.from(root.querySelectorAll(selector));
    }

    function cleanupSection(section) {
      if (section.__joybarbaCeremonialMatchaCleanup) {
        section.__joybarbaCeremonialMatchaCleanup();
      }
    }

    function initSection(section) {
      if (section.dataset.joybarbaCeremonialMatchaInitialized === 'true') {
        return;
      }

      const revealItems = Array.from(section.querySelectorAll('[data-jcm-reveal]'));
      const cards = Array.from(section.querySelectorAll('.joybarba-ceremonial-matcha__card'));
      const scroller = section.querySelector('.joybarba-ceremonial-matcha__cards');
      const nav = section.querySelector('[data-jcm-nav]');
      const prevButton = section.querySelector('[data-jcm-nav-prev]');
      const nextButton = section.querySelector('[data-jcm-nav-next]');
      const dots = Array.from(section.querySelectorAll('[data-jcm-nav-dot]'));
      const cleanupCallbacks = [];
      const dotHandlers = [];
      section.dataset.joybarbaCeremonialMatchaInitialized = 'true';

      revealItems.forEach(function (item, index) {
        item.style.setProperty('--jcm-reveal-delay', index * 90 + 'ms');
      });

      function setActiveNav(index) {
        dots.forEach(function (dot, dotIndex) {
          const isActive = dotIndex === index;

          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'step');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      function scrollToCard(index) {
        if (!cards[index] || !(scroller instanceof HTMLElement)) {
          return;
        }

        scroller.scrollTo({
          left: cards[index].offsetLeft - scroller.offsetLeft,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
        setActiveNav(index);
      }

      if (nav && scroller && cards.length > 1) {
        let activeIndex = 0;

        const updateActiveFromScroll = function () {
          if (!(scroller instanceof HTMLElement)) {
            return;
          }

          const scrollerRect = scroller.getBoundingClientRect();
          const scrollerCenter = scrollerRect.left + scrollerRect.width / 2;
          const closestIndex = cards.reduce(function (closest, card, index) {
            const rect = card.getBoundingClientRect();
            const cardCenter = rect.left + rect.width / 2;
            const distance = Math.abs(cardCenter - scrollerCenter);

            return distance < closest.distance ? { index: index, distance: distance } : closest;
          }, { index: 0, distance: Infinity }).index;

          activeIndex = closestIndex;
          setActiveNav(activeIndex);
        };

        const goToPrevious = function () {
          activeIndex = activeIndex === 0 ? cards.length - 1 : activeIndex - 1;
          scrollToCard(activeIndex);
        };

        const goToNext = function () {
          activeIndex = activeIndex === cards.length - 1 ? 0 : activeIndex + 1;
          scrollToCard(activeIndex);
        };

        prevButton?.addEventListener('click', goToPrevious);
        nextButton?.addEventListener('click', goToNext);
        scroller.addEventListener('scroll', updateActiveFromScroll, { passive: true });

        dots.forEach(function (dot, index) {
          const dotHandler = function () {
            activeIndex = index;
            scrollToCard(activeIndex);
          };

          dot.addEventListener('click', dotHandler);
          dotHandlers.push([dot, dotHandler]);
        });

        cleanupCallbacks.push(function () {
          prevButton?.removeEventListener('click', goToPrevious);
          nextButton?.removeEventListener('click', goToNext);
          scroller.removeEventListener('scroll', updateActiveFromScroll);
          dotHandlers.forEach(function (handler) {
            handler[0].removeEventListener('click', handler[1]);
          });
        });
      }

      if (!('IntersectionObserver' in window)) {
        revealItems.forEach(function (item) {
          item.classList.add('is-visible');
        });
        section.__joybarbaCeremonialMatchaCleanup = function () {
          cleanupCallbacks.forEach(function (cleanup) {
            cleanup();
          });
          section.dataset.joybarbaCeremonialMatchaInitialized = 'false';
          delete section.__joybarbaCeremonialMatchaCleanup;
        };
        return;
      }

      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.18,
          rootMargin: '0px 0px -8% 0px',
        }
      );

      revealItems.forEach(function (item) {
        observer.observe(item);
      });

      section.__joybarbaCeremonialMatchaCleanup = function () {
        observer.disconnect();
        cleanupCallbacks.forEach(function (cleanup) {
          cleanup();
        });
        section.dataset.joybarbaCeremonialMatchaInitialized = 'false';
        delete section.__joybarbaCeremonialMatchaCleanup;
      };
    }

    function init(root) {
      getSections(root).forEach(function (section) {
        initSection(section);
      });
    }

    ready(function () {
      init(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      getSections(event.target).forEach(cleanupSection);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joybarba-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const selector = '[data-joybarba-hero]';

    function ready(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
      } else {
        callback();
      }
    }

    function getHeroes(root) {
      if (root instanceof Element && root.matches(selector)) {
        return [root];
      }

      return Array.from(root.querySelectorAll(selector));
    }

    function cleanupHero(hero) {
      if (hero.__joybarbaHeroCleanup) {
        hero.__joybarbaHeroCleanup();
      }
    }

    function syncActive(layers, activeIndex) {
      layers.forEach(function (layer, index) {
        const active = index === activeIndex;
        layer.classList.toggle('is-active', active);
        layer.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }

    function buildBlinds(group, count) {
      const frag = document.createDocumentFragment();
      for (let i = 0; i < count; i += 1) {
        const blind = document.createElement('div');
        blind.className = 'joybarba-hero__blind';
        blind.setAttribute('data-joybarba-blind', '');
        blind.style.setProperty('--blind-i', String(i));
        blind.style.setProperty('--blind-n', String(count));
        frag.appendChild(blind);
      }
      group.appendChild(frag);
      return Array.from(group.children);
    }

    function destroyBlinds(group) {
      while (group.firstChild) {
        group.removeChild(group.firstChild);
      }
    }

    function waitForGsap(callback, attempt) {
      if (window.gsap) {
        callback(window.gsap);
        return;
      }

      if ((attempt || 0) > 40) {
        return;
      }

      window.setTimeout(function () {
        waitForGsap(callback, (attempt || 0) + 1);
      }, 100);
    }

    function initHero(hero, gsap) {
      if (hero.dataset.joybarbaInitialized === 'true') {
        return;
      }

      const section = hero.closest('.joybarba-hero');
      if (!section) {
        return;
      }

      const textLayers = Array.from(hero.querySelectorAll('[data-joybarba-text-layer]'));
      const overlayLayers = Array.from(hero.querySelectorAll('[data-joybarba-overlay-layer]'));
      const layerImages = Array.from(hero.querySelectorAll('[data-joybarba-layer-image]'));
      const blindGroupNodes = Array.from(hero.querySelectorAll('[data-joybarba-blinds]'));
      const navItems = Array.from(hero.querySelectorAll('[data-joybarba-nav-item]'));
      const sceneCount = Math.max(textLayers.length, 1);
      const desktopBlindCount = Number.parseInt(hero.dataset.joybarbaBlindCount, 10) || 16;
      const mobileBlindCount =
        Number.parseInt(hero.dataset.joybarbaMobileBlindCount, 10) ||
        Math.max(1, Math.floor(desktopBlindCount / 2));
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const cleanupFns = [];

      if (!textLayers.length) {
        hero.__joybarbaHeroCleanup = function () {
          hero.dataset.joybarbaInitialized = 'false';
          delete hero.__joybarbaHeroCleanup;
        };
        return;
      }

      hero.dataset.joybarbaInitialized = 'true';
      syncActive(textLayers, 0);
      syncActive(overlayLayers, 0);

      let activeScene = 0;
      let visibleTextScene = 0;
      let currentCount = mobileQuery.matches ? mobileBlindCount : desktopBlindCount;
      let pointerState = null;

      let blindGroups = blindGroupNodes.map(function (node) {
        return buildBlinds(node, currentCount);
      });

      function isReducedMotion() {
        return reducedMotionQuery.matches;
      }

      function clampScene(index) {
        return Math.max(0, Math.min(sceneCount - 1, index));
      }

      function addListener(target, eventName, handler, options) {
        target.addEventListener(eventName, handler, options);
        cleanupFns.push(function () {
          target.removeEventListener(eventName, handler, options);
        });
      }

      function syncNav(activeIndex) {
        navItems.forEach(function (item, index) {
          const active = index === activeIndex;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-current', active ? 'true' : 'false');
          if (active && item.scrollIntoView) {
            item.scrollIntoView({
              block: 'nearest',
              inline: 'nearest',
              behavior: isReducedMotion() ? 'auto' : 'smooth',
            });
          }
        });
      }

      function applyStaticVisibility(currentScene) {
        const baseScene = hero.querySelector('.joybarba-hero__base-scene');
        if (baseScene) {
          gsap.set(baseScene, { autoAlpha: currentScene === 0 ? 1 : 0 });
        }

        blindGroupNodes.forEach(function (node, stage) {
          const isNeeded = (currentScene > 0 && stage === currentScene - 1);
          gsap.set(node, { autoAlpha: isNeeded ? 1 : 0 });
        });
      }

      const context = gsap.context(function () {
        gsap.set(textLayers, { autoAlpha: 0, y: 30 });
        gsap.set(textLayers[0], { autoAlpha: 1, y: 0 });
        gsap.set(blindGroupNodes, { autoAlpha: 0 });
        gsap.set(layerImages, { autoAlpha: 0, y: isReducedMotion() ? 0 : 24, scale: isReducedMotion() ? 1 : 0.92, rotation: isReducedMotion() ? 0 : -5 });
        textLayers.forEach(function (layer, index) {
          gsap.set(Array.from(layer.children), {
            autoAlpha: index === 0 ? 1 : 0,
            y: index === 0 || isReducedMotion() ? 0 : 22,
          });
        });
        blindGroups.forEach(function (group) {
          gsap.set(group, { clipPath: 'inset(0 100% 0 0)' });
        });

        const firstLayerImages = Array.from(textLayers[0].querySelectorAll('[data-joybarba-layer-image]'));
        if (isReducedMotion()) {
          gsap.set(firstLayerImages, { autoAlpha: 1, y: 0, scale: 1, rotation: 0 });
        } else {
          gsap.to(firstLayerImages, {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            rotation: 0,
            duration: 0.9,
            delay: 0.24,
            ease: 'back.out(1.35)',
            overwrite: true,
          });
        }

        syncActive(textLayers, 0);
        syncActive(overlayLayers, 0);
        syncNav(0);
        applyStaticVisibility(0);
      }, section);

      function setStageOpen(stageIndex, open, animate, onComplete) {
        const group = blindGroups[stageIndex];
        const groupNode = blindGroupNodes[stageIndex];

        if (!group) {
          if (onComplete) {
            onComplete();
          }
          return;
        }

        gsap.killTweensOf(group);
        if (groupNode) {
          gsap.killTweensOf(groupNode);
        }

        if (groupNode && open) {
          gsap.set(groupNode, { autoAlpha: 1 });
        }

        if (animate === false || isReducedMotion()) {
          gsap.set(group, {
            clipPath: open ? 'inset(0 0% 0 0)' : 'inset(0 100% 0 0)',
          });
          if (groupNode) {
            gsap.set(groupNode, { autoAlpha: open ? 1 : 0 });
          }
          if (onComplete) {
            onComplete();
          }
          return;
        }

        gsap.to(group, {
          clipPath: open ? 'inset(0 0% 0 0)' : 'inset(0 100% 0 0)',
          duration: open ? 1.35 : 0.95,
          overwrite: true,
          stagger: {
            each: open ? 0.055 : 0.032,
            from: open ? 'start' : 'end',
            ease: 'sine.inOut',
          },
          ease: 'power3.inOut',
          onComplete: function () {
            if (!open && groupNode) {
              gsap.set(groupNode, { autoAlpha: 0 });
            }
            if (onComplete) {
              onComplete();
            }
          },
        });
      }

      function animateTextToScene(nextScene, direction) {
        if (nextScene === visibleTextScene) {
          return;
        }

        const outgoing = textLayers[visibleTextScene];
        const incoming = textLayers[nextScene];

        if (!outgoing || !incoming) {
          visibleTextScene = nextScene;
          syncActive(textLayers, nextScene);
          syncActive(overlayLayers, nextScene);
          return;
        }

        if (isReducedMotion()) {
          setSceneState(nextScene);
          return;
        }

        const outgoingItems = Array.from(outgoing.children);
        const incomingItems = Array.from(incoming.children);
        const outgoingLayerImages = Array.from(outgoing.querySelectorAll('[data-joybarba-layer-image]'));
        const incomingLayerImages = Array.from(incoming.querySelectorAll('[data-joybarba-layer-image]'));
        const animatedTargets = [outgoing, incoming].concat(
          outgoingItems,
          incomingItems,
          outgoingLayerImages,
          incomingLayerImages
        );

        gsap.killTweensOf(animatedTargets);
        gsap.set(incoming, {
          autoAlpha: 1,
          y: 0,
        });
        gsap.set(incomingItems, {
          autoAlpha: 0,
          y: direction > 0 ? 24 : -18,
        });
        gsap.set(incomingLayerImages, {
          autoAlpha: 0,
          y: direction > 0 ? 34 : -28,
          scale: 0.9,
          rotation: direction > 0 ? -6 : 6,
        });
        syncActive(textLayers, nextScene);
        syncActive(overlayLayers, nextScene);
        gsap
          .timeline({ defaults: { overwrite: 'auto' } })
          .to(
            outgoingItems,
            {
              autoAlpha: 0,
              y: direction > 0 ? -16 : 18,
              duration: 0.44,
              stagger: { amount: 0.08, from: 'start' },
              ease: 'power2.inOut',
            },
            0
          )
          .to(
            outgoingLayerImages,
            {
              autoAlpha: 0,
              y: direction > 0 ? -22 : 20,
              scale: 0.94,
              rotation: direction > 0 ? 5 : -5,
              duration: 0.38,
              ease: 'power2.in',
            },
            0
          )
          .to(
            outgoing,
            {
              autoAlpha: 0,
              y: direction > 0 ? -12 : 14,
              duration: 0.54,
              ease: 'power2.inOut',
            },
            0
          )
          .to(
            incomingItems,
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.82,
              stagger: { amount: 0.16, from: 'start' },
              ease: 'power3.out',
            },
            0.18
          )
          .to(
            incomingLayerImages,
            {
              autoAlpha: 1,
              y: 0,
              scale: 1,
              rotation: 0,
              duration: 0.9,
              ease: 'back.out(1.35)',
            },
            0.32
          );

        visibleTextScene = nextScene;
      }

      function goToScene(nextScene) {
        nextScene = clampScene(nextScene);
        if (nextScene === activeScene) {
          return;
        }

        const previousScene = activeScene;
        const direction = nextScene > previousScene ? 1 : -1;
        const animatedStage = direction > 0 ? nextScene - 1 : nextScene;

        activeScene = nextScene;
        syncNav(nextScene);

        // Ensure the base scene is visible during transitions
        const baseScene = hero.querySelector('.joybarba-hero__base-scene');
        if (baseScene) {
          gsap.set(baseScene, { autoAlpha: 1 });
        }

        blindGroups.forEach(function (_group, stage) {
          const shouldOpen = stage < nextScene;
          const shouldAnimate = stage === animatedStage;

          setStageOpen(
            stage,
            shouldOpen,
            shouldAnimate,
            shouldAnimate
              ? function () {
                  if (direction > 0 && activeScene === nextScene) {
                    animateTextToScene(nextScene, direction);
                  }
                  applyStaticVisibility(nextScene);
                }
              : null
          );
        });

        if (direction < 0) {
          animateTextToScene(nextScene, direction);
        }
      }

      function setSceneState(nextScene) {
        activeScene = nextScene;
        visibleTextScene = nextScene;

        blindGroups.forEach(function (_group, stage) {
          setStageOpen(stage, stage < nextScene, false);
        });

        textLayers.forEach(function (layer, index) {
          const active = index === nextScene;
          const layerChildren = Array.from(layer.children);
          const layerImages = Array.from(layer.querySelectorAll('[data-joybarba-layer-image]'));
          const targets = [layer].concat(layerChildren, layerImages);

          gsap.killTweensOf(targets);
          gsap.set(layer, { autoAlpha: active ? 1 : 0, y: 0 });
          gsap.set(layerChildren, { autoAlpha: active ? 1 : 0, y: 0 });
          gsap.set(layerImages, {
            autoAlpha: active ? 1 : 0,
            y: 0,
            scale: 1,
            rotation: 0,
          });
        });

        syncActive(textLayers, nextScene);
        syncActive(overlayLayers, nextScene);
        syncNav(nextScene);
        applyStaticVisibility(nextScene);
      }

      function rebuildBlinds() {
        const newCount = mobileQuery.matches ? mobileBlindCount : desktopBlindCount;
        if (newCount === currentCount) {
          return false;
        }

        currentCount = newCount;

        blindGroupNodes.forEach(function (node, idx) {
          gsap.killTweensOf(blindGroups[idx]);
          destroyBlinds(node);
          blindGroups[idx] = buildBlinds(node, currentCount);
        });

        blindGroups.forEach(function (group, idx) {
          gsap.set(group, {
            clipPath: idx < activeScene ? 'inset(0 0% 0 0)' : 'inset(0 100% 0 0)',
          });
        });

        applyStaticVisibility(activeScene);
        return true;
      }

      function handleViewportChange() {
        rebuildBlinds();
        setSceneState(activeScene);
      }

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', handleViewportChange);
        cleanupFns.push(function () {
          mobileQuery.removeEventListener('change', handleViewportChange);
        });
      } else if (mobileQuery.addListener) {
        mobileQuery.addListener(handleViewportChange);
        cleanupFns.push(function () {
          mobileQuery.removeListener(handleViewportChange);
        });
      }

      navItems.forEach(function (item) {
        addListener(item, 'click', function () {
          goToScene(Number.parseInt(item.dataset.joybarbaNavIndex, 10) || 0);
        });
      });

      addListener(hero, 'pointerdown', function (event) {
        if (event.button !== undefined && event.button !== 0) {
          return;
        }

        if (event.target.closest('a, button, input, label, select, textarea, summary')) {
          return;
        }

        pointerState = {
          id: event.pointerId,
          x: event.clientX,
          y: event.clientY,
          time: Date.now(),
          dragging: false,
        };

        if (hero.setPointerCapture) {
          hero.setPointerCapture(event.pointerId);
        }
      });

      addListener(hero, 'pointermove', function (event) {
        if (!pointerState || pointerState.id !== event.pointerId) {
          return;
        }

        const deltaX = event.clientX - pointerState.x;
        const deltaY = event.clientY - pointerState.y;
        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);

        if (!pointerState.dragging && absX > 12 && absX > absY * 1.2) {
          pointerState.dragging = true;
        }

        if (pointerState.dragging) {
          event.preventDefault();
        }
      });

      function finishPointer(event) {
        if (!pointerState || pointerState.id !== event.pointerId) {
          pointerState = null;
          return;
        }

        const deltaX = event.clientX - pointerState.x;
        const deltaY = event.clientY - pointerState.y;
        const elapsed = Math.max(1, Date.now() - pointerState.time);
        const threshold = Math.min(88, Math.max(44, hero.clientWidth * 0.16));
        const velocity = Math.abs(deltaX) / elapsed;
        const horizontal = Math.abs(deltaX) > Math.abs(deltaY) * 1.2;
        const shouldAdvance = horizontal && (Math.abs(deltaX) >= threshold || (Math.abs(deltaX) >= 28 && velocity > 0.45));

        if (shouldAdvance) {
          goToScene(activeScene + (deltaX < 0 ? 1 : -1));
        }

        if (hero.releasePointerCapture) {
          try {
            hero.releasePointerCapture(event.pointerId);
          } catch (error) {
            // Pointer capture may already be released by the browser.
          }
        }

        pointerState = null;
      }

      addListener(hero, 'pointerup', finishPointer);
      addListener(hero, 'pointercancel', finishPointer);

      addListener(hero, 'keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goToScene(activeScene - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          goToScene(activeScene + 1);
        }
      });

      hero.__joybarbaHeroCleanup = function () {
        gsap.killTweensOf(textLayers);
        gsap.killTweensOf(layerImages);
        gsap.killTweensOf(blindGroupNodes);
        blindGroups.forEach(function (group) {
          gsap.killTweensOf(group);
        });
        context.revert();
        cleanupFns.forEach(function (cleanup) {
          cleanup();
        });
        blindGroupNodes.forEach(destroyBlinds);
        syncActive(textLayers, 0);
        syncActive(overlayLayers, 0);
        activeScene = 0;
        hero.dataset.joybarbaInitialized = 'false';
        delete hero.__joybarbaHeroCleanup;
      };
    }

    function init(root) {
      waitForGsap(function (gsap) {
        getHeroes(root).forEach(function (hero) {
          initHero(hero, gsap);
        });
      });
    }

    ready(function () {
      init(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      getHeroes(event.target).forEach(cleanupHero);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joybarba-images-scroll-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const selector = '[data-joybarba-images-scroll-gallery-track]';

    function ready(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
      } else {
        callback();
      }
    }

    function getTracks(root) {
      if (root instanceof Element && root.matches(selector)) {
        return [root];
      }

      return Array.from(root.querySelectorAll(selector));
    }

    function cleanupTrack(track) {
      if (track.__joybarbaImagesScrollGalleryCleanup) {
        track.__joybarbaImagesScrollGalleryCleanup();
      }
    }

    function initTrack(track) {
      cleanupTrack(track);

      if (track.dataset.autoScroll !== 'true') {
        return;
      }

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      let frame = 0;
      let previousTime = 0;
      let direction = 1;
      let position = track.scrollLeft;
      let paused = false;
      let userPauseUntil = 0;
      const speed = Number(track.dataset.scrollSpeed) || 60;
      const pauseOnHover = track.dataset.pauseOnHover === 'true';

      function maxScroll() {
        return Math.max(0, track.scrollWidth - track.clientWidth);
      }

      function step(time) {
        const maximum = maxScroll();

        if (maximum > 1) {
          position = Math.min(position, maximum);

          if (!previousTime) {
            previousTime = time;
          }

          const delta = Math.min(64, time - previousTime) / 1000;
          previousTime = time;

          if (!paused && Date.now() > userPauseUntil) {
            position += direction * speed * delta;

            if (position >= maximum - 1) {
              position = maximum;
              direction = -1;
            } else if (position <= 1) {
              position = 0;
              direction = 1;
            }

            track.scrollLeft = position;
          }
        } else {
          previousTime = time;
        }

        frame = window.requestAnimationFrame(step);
      }

      function pauseTemporarily() {
        position = track.scrollLeft;
        userPauseUntil = Date.now() + 1600;
      }

      function setPaused(value) {
        paused = value;
        previousTime = 0;
      }

      if (pauseOnHover) {
        track.addEventListener('mouseenter', function () {
          setPaused(true);
        });

        track.addEventListener('mouseleave', function () {
          setPaused(false);
        });

        track.addEventListener('focusin', function () {
          setPaused(true);
        });

        track.addEventListener('focusout', function () {
          position = track.scrollLeft;
          setPaused(false);
        });
      }

      track.addEventListener('wheel', pauseTemporarily, { passive: true });
      track.addEventListener('pointerdown', pauseTemporarily, { passive: true });
      track.addEventListener('touchstart', pauseTemporarily, { passive: true });

      frame = window.requestAnimationFrame(step);

      track.__joybarbaImagesScrollGalleryCleanup = function () {
        window.cancelAnimationFrame(frame);
        delete track.__joybarbaImagesScrollGalleryCleanup;
      };
    }

    function init(root) {
      getTracks(root).forEach(initTrack);
    }

    ready(function () {
      init(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      getTracks(event.target).forEach(cleanupTrack);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joybarba-mate-benefits"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const selector = '[data-joybarba-mate-benefits]';

    function ready(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
      } else {
        callback();
      }
    }

    function getSections(root) {
      if (root instanceof Element && root.matches(selector)) {
        return [root];
      }

      return Array.from(root.querySelectorAll(selector));
    }

    function cleanupSection(section) {
      if (section.__joybarbaMateBenefitsCleanup) {
        section.__joybarbaMateBenefitsCleanup();
      }
    }

    function initSection(section) {
      if (section.dataset.joybarbaMateBenefitsInitialized === 'true') {
        return;
      }

      const posters = Array.from(section.querySelectorAll('.joybarba-mate-benefits__poster'));
      const scroller = section.querySelector('[data-jmb-posters]');
      const nav = section.querySelector('[data-jmb-nav]');
      const prevButton = section.querySelector('[data-jmb-nav-prev]');
      const nextButton = section.querySelector('[data-jmb-nav-next]');
      const dots = Array.from(section.querySelectorAll('[data-jmb-nav-dot]'));
      const dotHandlers = [];

      section.dataset.joybarbaMateBenefitsInitialized = 'true';

      if (!nav || !(scroller instanceof HTMLElement) || posters.length <= 1) {
        return;
      }

      let activeIndex = 0;

      function setActiveNav(index) {
        dots.forEach(function (dot, dotIndex) {
          const isActive = dotIndex === index;

          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'step');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      function scrollToPoster(index) {
        if (!posters[index]) {
          return;
        }

        scroller.scrollTo({
          left: posters[index].offsetLeft - scroller.offsetLeft,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
        setActiveNav(index);
      }

      const updateActiveFromScroll = function () {
        const scrollerRect = scroller.getBoundingClientRect();
        const scrollerCenter = scrollerRect.left + scrollerRect.width / 2;
        const closestIndex = posters.reduce(function (closest, poster, index) {
          const rect = poster.getBoundingClientRect();
          const posterCenter = rect.left + rect.width / 2;
          const distance = Math.abs(posterCenter - scrollerCenter);

          return distance < closest.distance ? { index: index, distance: distance } : closest;
        }, { index: 0, distance: Infinity }).index;

        activeIndex = closestIndex;
        setActiveNav(activeIndex);
      };

      const goToPrevious = function () {
        activeIndex = activeIndex === 0 ? posters.length - 1 : activeIndex - 1;
        scrollToPoster(activeIndex);
      };

      const goToNext = function () {
        activeIndex = activeIndex === posters.length - 1 ? 0 : activeIndex + 1;
        scrollToPoster(activeIndex);
      };

      prevButton?.addEventListener('click', goToPrevious);
      nextButton?.addEventListener('click', goToNext);
      scroller.addEventListener('scroll', updateActiveFromScroll, { passive: true });

      dots.forEach(function (dot, index) {
        const dotHandler = function () {
          activeIndex = index;
          scrollToPoster(activeIndex);
        };

        dot.addEventListener('click', dotHandler);
        dotHandlers.push([dot, dotHandler]);
      });

      section.__joybarbaMateBenefitsCleanup = function () {
        prevButton?.removeEventListener('click', goToPrevious);
        nextButton?.removeEventListener('click', goToNext);
        scroller.removeEventListener('scroll', updateActiveFromScroll);
        dotHandlers.forEach(function (handler) {
          handler[0].removeEventListener('click', handler[1]);
        });
        section.dataset.joybarbaMateBenefitsInitialized = 'false';
        delete section.__joybarbaMateBenefitsCleanup;
      };
    }

    function init(root) {
      getSections(root).forEach(function (section) {
        initSection(section);
      });
    }

    ready(function () {
      init(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      getSections(event.target).forEach(cleanupSection);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joybarba-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const selector = '[data-joybarba-product-grid]';

    function ready(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
      } else {
        callback();
      }
    }

    function getGrids(root) {
      if (root instanceof Element && root.matches(selector)) {
        return [root];
      }

      return Array.from(root.querySelectorAll(selector));
    }

    function cleanupGrid(grid) {
      if (grid.__joybarbaProductGridCleanup) {
        grid.__joybarbaProductGridCleanup();
      }
    }

    function waitForGsap(callback, attempt) {
      if (window.gsap && window.ScrollTrigger) {
        callback(window.gsap, window.ScrollTrigger);
        return;
      }

      if ((attempt || 0) > 40) {
        return;
      }

      window.setTimeout(function () {
        waitForGsap(callback, (attempt || 0) + 1);
      }, 100);
    }

    function initGrid(grid, gsap, ScrollTrigger) {
      if (grid.dataset.joybarbaProductGridInitialized === 'true') {
        return;
      }

      const section = grid.closest('.joybarba-product-grid');
      const intro = grid.querySelector('[data-joybarba-product-grid-intro]');
      const cards = Array.from(grid.querySelectorAll('[data-joybarba-product-grid-card]'));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!section) {
        return;
      }

      grid.dataset.joybarbaProductGridInitialized = 'true';

      if (reducedMotion) {
        return;
      }

      const context = gsap.context(function () {
        if (intro) {
          gsap.fromTo(
            intro,
            { autoAlpha: 0, y: 36 },
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.9,
              ease: 'power3.out',
              scrollTrigger: {
                trigger: intro,
                start: 'top 85%',
                toggleActions: 'play none none none',
              },
            }
          );
        }

        cards.forEach(function (card, index) {
          gsap.fromTo(
            card,
            { autoAlpha: 0, y: 72 },
            {
              autoAlpha: 1,
              y: 0,
              duration: 1.1,
              delay: index * 0.08,
              ease: 'power3.out',
              scrollTrigger: {
                trigger: card,
                start: 'top 88%',
                toggleActions: 'play none none none',
              },
            }
          );
        });
      }, section);

      grid.__joybarbaProductGridCleanup = function () {
        context.revert();
        grid.dataset.joybarbaProductGridInitialized = 'false';
        delete grid.__joybarbaProductGridCleanup;
      };
    }

    function init(root) {
      waitForGsap(function (gsap, ScrollTrigger) {
        gsap.registerPlugin(ScrollTrigger);
        getGrids(root).forEach(function (grid) {
          initGrid(grid, gsap, ScrollTrigger);
        });
      });
    }

    ready(function () {
      init(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      getGrids(event.target).forEach(cleanupGrid);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joybarba-testimonials-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const selector = '[data-joybarba-testimonials-banner]';

    function ready(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
      } else {
        callback();
      }
    }

    function getBanners(root) {
      if (root instanceof Element && root.matches(selector)) {
        return [root];
      }

      return Array.from(root.querySelectorAll(selector));
    }

    function cleanupBanner(banner) {
      if (banner.__joybarbaTestimonialsBannerCleanup) {
        banner.__joybarbaTestimonialsBannerCleanup();
      }
    }

    function initBanner(banner) {
      cleanupBanner(banner);

      const slides = Array.from(banner.querySelectorAll('[data-jtb-slide]'));
      const dots = Array.from(banner.querySelectorAll('[data-jtb-dot]'));
      const prevButton = banner.querySelector('[data-jtb-prev]');
      const nextButton = banner.querySelector('[data-jtb-next]');

      if (slides.length <= 1) {
        return;
      }

      let activeIndex = slides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      });
      let timer = 0;
      const autoplay = banner.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplayDelay = Math.max(2500, Number(banner.dataset.autoplayDelay) || 5000);

      if (activeIndex < 0) {
        activeIndex = 0;
      }

      function setActive(index) {
        activeIndex = (index + slides.length) % slides.length;

        slides.forEach(function (slide, slideIndex) {
          const isActive = slideIndex === activeIndex;

          slide.classList.toggle('is-active', isActive);
          if (isActive) {
            slide.removeAttribute('aria-hidden');
          } else {
            slide.setAttribute('aria-hidden', 'true');
          }
        });

        dots.forEach(function (dot, dotIndex) {
          const isActive = dotIndex === activeIndex;

          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'step');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      function stopAutoplay() {
        if (timer) {
          window.clearInterval(timer);
          timer = 0;
        }
      }

      function startAutoplay() {
        stopAutoplay();

        if (!autoplay) {
          return;
        }

        timer = window.setInterval(function () {
          setActive(activeIndex + 1);
        }, autoplayDelay);
      }

      function goToPrevious() {
        setActive(activeIndex - 1);
        startAutoplay();
      }

      function goToNext() {
        setActive(activeIndex + 1);
        startAutoplay();
      }

      const dotHandlers = dots.map(function (dot, index) {
        const handler = function () {
          setActive(index);
          startAutoplay();
        };

        dot.addEventListener('click', handler);
        return [dot, handler];
      });

      prevButton?.addEventListener('click', goToPrevious);
      nextButton?.addEventListener('click', goToNext);
      banner.addEventListener('mouseenter', stopAutoplay);
      banner.addEventListener('mouseleave', startAutoplay);
      banner.addEventListener('focusin', stopAutoplay);
      banner.addEventListener('focusout', startAutoplay);

      setActive(activeIndex);
      startAutoplay();

      banner.__joybarbaTestimonialsBannerCleanup = function () {
        stopAutoplay();
        prevButton?.removeEventListener('click', goToPrevious);
        nextButton?.removeEventListener('click', goToNext);
        banner.removeEventListener('mouseenter', stopAutoplay);
        banner.removeEventListener('mouseleave', startAutoplay);
        banner.removeEventListener('focusin', stopAutoplay);
        banner.removeEventListener('focusout', startAutoplay);
        dotHandlers.forEach(function (handler) {
          handler[0].removeEventListener('click', handler[1]);
        });
        delete banner.__joybarbaTestimonialsBannerCleanup;
      };
    }

    function init(root) {
      getBanners(root).forEach(initBanner);
    }

    ready(function () {
      init(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      getBanners(event.target).forEach(cleanupBanner);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["matcha-brew"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const selector = '[data-testid="matcha-brew"]';

    function ready(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
      } else {
        callback();
      }
    }

    function getSections(root) {
      if (root instanceof Element && root.matches(selector)) {
        return [root];
      }
      return Array.from(root.querySelectorAll(selector));
    }

    function waitForGsap(callback, attempt) {
      if (window.gsap && window.ScrollTrigger) {
        callback(window.gsap, window.ScrollTrigger);
        return;
      }
      if ((attempt || 0) > 40) {
        console.warn("Matcha Brew Steps: GSAP/ScrollTrigger not found after 40 attempts");
        return;
      }
      window.setTimeout(function () {
        waitForGsap(callback, (attempt || 0) + 1);
      }, 100);
    }

    function initBrewSteps(sectionEl, gsap, ScrollTrigger) {
      if (!sectionEl) return;
      console.log("Matcha Brew Steps ScrollTrigger init starting...", sectionEl);
      
      if (sectionEl.__matchaBrewStepsCleanup) {
        sectionEl.__matchaBrewStepsCleanup();
      }

      const cards = Array.from(sectionEl.querySelectorAll('.brew-step-card'));
      if (cards.length === 0) {
        console.warn("Matcha Brew Steps: No cards found in section element", sectionEl);
        return;
      }
      
      console.log(`Matcha Brew Steps: Found ${cards.length} cards. Initializing ScrollTrigger...`);
      const mm = gsap.matchMedia();

      mm.add("(max-width: 989px)", () => {
        console.log("Matcha Brew Steps: Mobile matchMedia active");
        cards.forEach((card, index) => {
          ScrollTrigger.create({
            trigger: card,
            start: "top 40%",
            end: "bottom 30%",
            onEnter: () => {
              card.classList.add("is-hovered");
              console.log(`Matcha Brew Steps Card ${index} entered viewport center (Active)`);
            },
            onLeave: () => {
              card.classList.remove("is-hovered");
              console.log(`Matcha Brew Steps Card ${index} left viewport top (Normal)`);
            },
            onEnterBack: () => {
              card.classList.add("is-hovered");
              console.log(`Matcha Brew Steps Card ${index} entered viewport center from top (Active)`);
            },
            onLeaveBack: () => {
              card.classList.remove("is-hovered");
              console.log(`Matcha Brew Steps Card ${index} left viewport bottom (Normal)`);
            }
          });
          console.log(`Matcha Brew Steps: Created ScrollTrigger for card ${index}`);
        });

        // Force ScrollTrigger to refresh immediately after creation to resolve coordinates
        ScrollTrigger.refresh();
        console.log("Matcha Brew Steps: ScrollTrigger.refresh() called");

        // Set delayed refreshes to handle dynamic layouts / lazy image rendering
        const refreshTimer1 = window.setTimeout(() => {
          ScrollTrigger.refresh();
          console.log("Matcha Brew Steps: Delayed ScrollTrigger.refresh() executed (500ms)");
        }, 500);

        const refreshTimer2 = window.setTimeout(() => {
          ScrollTrigger.refresh();
          console.log("Matcha Brew Steps: Delayed ScrollTrigger.refresh() executed (1500ms)");
        }, 1500);

        return () => {
          console.log("Matcha Brew Steps: Mobile matchMedia cleaning up");
          window.clearTimeout(refreshTimer1);
          window.clearTimeout(refreshTimer2);
          cards.forEach(card => card.classList.remove('is-hovered'));
        };
      });

      sectionEl.__matchaBrewStepsCleanup = function() {
        mm.revert();
      };
    }

    function init(root) {
      waitForGsap(function (gsap, ScrollTrigger) {
        gsap.registerPlugin(ScrollTrigger);
        const sections = getSections(root);
        console.log(`Matcha Brew Steps: Found ${sections.length} showcase elements to init`);
        sections.forEach(function(sectionEl) {
          initBrewSteps(sectionEl, gsap, ScrollTrigger);
        });
      });
    }

    ready(function () {
      console.log("Matcha Brew Steps: Document ready, initializing...");
      init(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      console.log("Matcha Brew Steps: Section load event caught");
      init(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      console.log("Matcha Brew Steps: Section unload event caught");
      getSections(event.target).forEach(function (sectionEl) {
        if (sectionEl.__matchaBrewStepsCleanup) {
          sectionEl.__matchaBrewStepsCleanup();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["matcha-showcase"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const selector = '[data-testid="matcha-showcase"]';

    function ready(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
      } else {
        callback();
      }
    }

    function getSections(root) {
      if (root instanceof Element && root.matches(selector)) {
        return [root];
      }
      return Array.from(root.querySelectorAll(selector));
    }

    function waitForGsap(callback, attempt) {
      if (window.gsap && window.ScrollTrigger) {
        callback(window.gsap, window.ScrollTrigger);
        return;
      }
      if ((attempt || 0) > 40) {
        console.warn("Matcha Showcase: GSAP/ScrollTrigger not found after 40 attempts");
        return;
      }
      window.setTimeout(function () {
        waitForGsap(callback, (attempt || 0) + 1);
      }, 100);
    }

    function initShowcase(sectionEl, gsap, ScrollTrigger) {
      if (!sectionEl) return;
      console.log("Matcha Showcase ScrollTrigger init starting...", sectionEl);
      
      if (sectionEl.__matchaShowcaseCleanup) {
        sectionEl.__matchaShowcaseCleanup();
      }

      const cards = Array.from(sectionEl.querySelectorAll('.showcase-card'));
      if (cards.length === 0) {
        console.warn("Matcha Showcase: No cards found in section element", sectionEl);
        return;
      }
      
      console.log(`Matcha Showcase: Found ${cards.length} cards. Initializing ScrollTrigger...`);
      const mm = gsap.matchMedia();

      mm.add("(max-width: 989px)", () => {
        console.log("Matcha Showcase: Mobile matchMedia active");
        cards.forEach((card, index) => {
          ScrollTrigger.create({
            trigger: card,
            start: "top 40%",
            end: "bottom 30%",
            onEnter: () => {
              card.classList.add("is-hovered");
              console.log(`Card ${index} entered viewport center (Active)`);
            },
            onLeave: () => {
              card.classList.remove("is-hovered");
              console.log(`Card ${index} left viewport top (Normal)`);
            },
            onEnterBack: () => {
              card.classList.add("is-hovered");
              console.log(`Card ${index} entered viewport center from top (Active)`);
            },
            onLeaveBack: () => {
              card.classList.remove("is-hovered");
              console.log(`Card ${index} left viewport bottom (Normal)`);
            }
          });
          console.log(`Matcha Showcase: Created ScrollTrigger for card ${index}`);
        });

        // Force ScrollTrigger to refresh immediately after creation to resolve coordinates
        ScrollTrigger.refresh();
        console.log("Matcha Showcase: ScrollTrigger.refresh() called");

        // Set delayed refreshes to handle dynamic layouts / lazy image rendering
        const refreshTimer1 = window.setTimeout(() => {
          ScrollTrigger.refresh();
          console.log("Matcha Showcase: Delayed ScrollTrigger.refresh() executed (500ms)");
        }, 500);

        const refreshTimer2 = window.setTimeout(() => {
          ScrollTrigger.refresh();
          console.log("Matcha Showcase: Delayed ScrollTrigger.refresh() executed (1500ms)");
        }, 1500);

        return () => {
          console.log("Matcha Showcase: Mobile matchMedia cleaning up");
          window.clearTimeout(refreshTimer1);
          window.clearTimeout(refreshTimer2);
          cards.forEach(card => card.classList.remove('is-hovered'));
        };
      });

      sectionEl.__matchaShowcaseCleanup = function() {
        mm.revert();
      };
    }

    function init(root) {
      waitForGsap(function (gsap, ScrollTrigger) {
        gsap.registerPlugin(ScrollTrigger);
        const sections = getSections(root);
        console.log(`Matcha Showcase: Found ${sections.length} showcase elements to init`);
        sections.forEach(function(sectionEl) {
          initShowcase(sectionEl, gsap, ScrollTrigger);
        });
      });
    }

    ready(function () {
      console.log("Matcha Showcase: Document ready, initializing...");
      init(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      console.log("Matcha Showcase: Section load event caught");
      init(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      console.log("Matcha Showcase: Section unload event caught");
      getSections(event.target).forEach(function (sectionEl) {
        if (sectionEl.__matchaShowcaseCleanup) {
          sectionEl.__matchaShowcaseCleanup();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yerba-brew"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const selector = '[data-testid="yerba-brew"]';

    function ready(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
      } else {
        callback();
      }
    }

    function getSections(root) {
      if (root instanceof Element && root.matches(selector)) {
        return [root];
      }
      return Array.from(root.querySelectorAll(selector));
    }

    function waitForGsap(callback, attempt) {
      if (window.gsap && window.ScrollTrigger) {
        callback(window.gsap, window.ScrollTrigger);
        return;
      }
      if ((attempt || 0) > 40) {
        console.warn("Yerba Brew Steps: GSAP/ScrollTrigger not found after 40 attempts");
        return;
      }
      window.setTimeout(function () {
        waitForGsap(callback, (attempt || 0) + 1);
      }, 100);
    }

    function initBrewSteps(sectionEl, gsap, ScrollTrigger) {
      if (!sectionEl) return;
      console.log("Yerba Brew Steps ScrollTrigger init starting...", sectionEl);
      
      if (sectionEl.__yerbaBrewStepsCleanup) {
        sectionEl.__yerbaBrewStepsCleanup();
      }

      const cards = Array.from(sectionEl.querySelectorAll('.brew-step-card'));
      if (cards.length === 0) {
        console.warn("Yerba Brew Steps: No cards found in section element", sectionEl);
        return;
      }
      
      console.log(`Yerba Brew Steps: Found ${cards.length} cards. Initializing ScrollTrigger...`);
      const mm = gsap.matchMedia();

      mm.add("(max-width: 989px)", () => {
        console.log("Yerba Brew Steps: Mobile matchMedia active");
        cards.forEach((card, index) => {
          ScrollTrigger.create({
            trigger: card,
            start: "top 40%",
            end: "bottom 30%",
            onEnter: () => {
              card.classList.add("is-hovered");
              console.log(`Yerba Brew Steps Card ${index} entered viewport center (Active)`);
            },
            onLeave: () => {
              card.classList.remove("is-hovered");
              console.log(`Yerba Brew Steps Card ${index} left viewport top (Normal)`);
            },
            onEnterBack: () => {
              card.classList.add("is-hovered");
              console.log(`Yerba Brew Steps Card ${index} entered viewport center from top (Active)`);
            },
            onLeaveBack: () => {
              card.classList.remove("is-hovered");
              console.log(`Yerba Brew Steps Card ${index} left viewport bottom (Normal)`);
            }
          });
          console.log(`Yerba Brew Steps: Created ScrollTrigger for card ${index}`);
        });

        // Force ScrollTrigger to refresh immediately after creation to resolve coordinates
        ScrollTrigger.refresh();
        console.log("Yerba Brew Steps: ScrollTrigger.refresh() called");

        // Set delayed refreshes to handle dynamic layouts / lazy image rendering
        const refreshTimer1 = window.setTimeout(() => {
          ScrollTrigger.refresh();
          console.log("Yerba Brew Steps: Delayed ScrollTrigger.refresh() executed (500ms)");
        }, 500);

        const refreshTimer2 = window.setTimeout(() => {
          ScrollTrigger.refresh();
          console.log("Yerba Brew Steps: Delayed ScrollTrigger.refresh() executed (1500ms)");
        }, 1500);

        return () => {
          console.log("Yerba Brew Steps: Mobile matchMedia cleaning up");
          window.clearTimeout(refreshTimer1);
          window.clearTimeout(refreshTimer2);
          cards.forEach(card => card.classList.remove('is-hovered'));
        };
      });

      sectionEl.__yerbaBrewStepsCleanup = function() {
        mm.revert();
      };
    }

    function init(root) {
      waitForGsap(function (gsap, ScrollTrigger) {
        gsap.registerPlugin(ScrollTrigger);
        const sections = getSections(root);
        console.log(`Yerba Brew Steps: Found ${sections.length} showcase elements to init`);
        sections.forEach(function(sectionEl) {
          initBrewSteps(sectionEl, gsap, ScrollTrigger);
        });
      });
    }

    ready(function () {
      console.log("Yerba Brew Steps: Document ready, initializing...");
      init(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      console.log("Yerba Brew Steps: Section load event caught");
      init(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      console.log("Yerba Brew Steps: Section unload event caught");
      getSections(event.target).forEach(function (sectionEl) {
        if (sectionEl.__yerbaBrewStepsCleanup) {
          sectionEl.__yerbaBrewStepsCleanup();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yerba-showcase"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const selector = '[data-testid="yerba-showcase"]';

    function ready(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
      } else {
        callback();
      }
    }

    function getSections(root) {
      if (root instanceof Element && root.matches(selector)) {
        return [root];
      }
      return Array.from(root.querySelectorAll(selector));
    }

    function waitForGsap(callback, attempt) {
      if (window.gsap && window.ScrollTrigger) {
        callback(window.gsap, window.ScrollTrigger);
        return;
      }
      if ((attempt || 0) > 40) {
        console.warn("Yerba Showcase: GSAP/ScrollTrigger not found after 40 attempts");
        return;
      }
      window.setTimeout(function () {
        waitForGsap(callback, (attempt || 0) + 1);
      }, 100);
    }

    function initShowcase(sectionEl, gsap, ScrollTrigger) {
      if (!sectionEl) return;
      console.log("Yerba Showcase ScrollTrigger init starting...", sectionEl);
      
      if (sectionEl.__yerbaShowcaseCleanup) {
        sectionEl.__yerbaShowcaseCleanup();
      }

      const cards = Array.from(sectionEl.querySelectorAll('.showcase-card'));
      if (cards.length === 0) {
        console.warn("Yerba Showcase: No cards found in section element", sectionEl);
        return;
      }
      
      console.log(`Yerba Showcase: Found ${cards.length} cards. Initializing ScrollTrigger...`);
      const mm = gsap.matchMedia();

      mm.add("(max-width: 989px)", () => {
        console.log("Yerba Showcase: Mobile matchMedia active");
        cards.forEach((card, index) => {
          ScrollTrigger.create({
            trigger: card,
            start: "top 40%",
            end: "bottom 30%",
            onEnter: () => {
              card.classList.add("is-hovered");
              console.log(`Yerba Showcase Card ${index} entered viewport center (Active)`);
            },
            onLeave: () => {
              card.classList.remove("is-hovered");
              console.log(`Yerba Showcase Card ${index} left viewport top (Normal)`);
            },
            onEnterBack: () => {
              card.classList.add("is-hovered");
              console.log(`Yerba Showcase Card ${index} entered viewport center from top (Active)`);
            },
            onLeaveBack: () => {
              card.classList.remove("is-hovered");
              console.log(`Yerba Showcase Card ${index} left viewport bottom (Normal)`);
            }
          });
          console.log(`Yerba Showcase: Created ScrollTrigger for card ${index}`);
        });

        // Force ScrollTrigger to refresh immediately after creation to resolve coordinates
        ScrollTrigger.refresh();
        console.log("Yerba Showcase: ScrollTrigger.refresh() called");

        // Set delayed refreshes to handle dynamic layouts / lazy image rendering
        const refreshTimer1 = window.setTimeout(() => {
          ScrollTrigger.refresh();
          console.log("Yerba Showcase: Delayed ScrollTrigger.refresh() executed (500ms)");
        }, 500);

        const refreshTimer2 = window.setTimeout(() => {
          ScrollTrigger.refresh();
          console.log("Yerba Showcase: Delayed ScrollTrigger.refresh() executed (1500ms)");
        }, 1500);

        return () => {
          console.log("Yerba Showcase: Mobile matchMedia cleaning up");
          window.clearTimeout(refreshTimer1);
          window.clearTimeout(refreshTimer2);
          cards.forEach(card => card.classList.remove('is-hovered'));
        };
      });

      sectionEl.__yerbaShowcaseCleanup = function() {
        mm.revert();
      };
    }

    function init(root) {
      waitForGsap(function (gsap, ScrollTrigger) {
        gsap.registerPlugin(ScrollTrigger);
        const sections = getSections(root);
        console.log(`Yerba Showcase: Found ${sections.length} showcase elements to init`);
        sections.forEach(function(sectionEl) {
          initShowcase(sectionEl, gsap, ScrollTrigger);
        });
      });
    }

    ready(function () {
      console.log("Yerba Showcase: Document ready, initializing...");
      init(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      console.log("Yerba Showcase: Section load event caught");
      init(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      console.log("Yerba Showcase: Section unload event caught");
      getSections(event.target).forEach(function (sectionEl) {
        if (sectionEl.__yerbaShowcaseCleanup) {
          sectionEl.__yerbaShowcaseCleanup();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
